// src/pages/Usuarios/index.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Usuarios.css';

const Usuarios = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    nome: '',
    documento: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Carregar usuários ao montar o componente
  useEffect(() => {
    carregarUsuarios();
  }, []);

  const carregarUsuarios = async () => {
    setLoading(true);
    setError('');
    
    try {
      const response = await axios.get('/api/usuarios');
      
      if (response.data.success) {
        setUsuarios(response.data.data);
      } else {
        setError(response.data.message || 'Erro ao carregar usuários');
      }
    } catch (error) {
      console.error('Error loading users:', error);
      setError('Erro ao carregar usuários: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  const handleFormChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const resetForm = () => {
    setFormData({
      name: '',
      email: '',
      password: '',
      nome: '',
      documento: ''
    });
    setEditingUser(null);
    setShowCreateForm(false);
    setError('');
    setSuccess('');
  };

  const criarUsuario = async () => {
    if (!formData.name.trim() || !formData.email.trim() || !formData.password.trim()) {
      setError('Nome, email e senha são obrigatórios');
      return;
    }

    if (formData.password.length < 6) {
      setError('A senha deve ter pelo menos 6 caracteres');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await axios.post('/api/usuarios', {
        name: formData.name.trim(),
        email: formData.email.trim().toLowerCase(),
        password: formData.password,
        nome: formData.nome.trim() || null,
        documento: formData.documento.trim() || null
      });

      if (response.data.success) {
        setSuccess('Usuário criado com sucesso!');
        resetForm();
        carregarUsuarios();
      } else {
        setError(response.data.message || 'Erro ao criar usuário');
      }
    } catch (error) {
      console.error('Error creating user:', error);
      setError('Erro ao criar usuário: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  const editarUsuario = async () => {
    if (!formData.name.trim() || !formData.email.trim()) {
      setError('Nome e email são obrigatórios');
      return;
    }

    if (formData.password && formData.password.length < 6) {
      setError('A senha deve ter pelo menos 6 caracteres (deixe em branco para não alterar)');
      return;
    }


    setLoading(true);
    setError('');

    try {
      const updateData = {
        name: formData.name.trim(),
        email: formData.email.trim().toLowerCase(),
        nome: formData.nome.trim() || null,
        documento: formData.documento.trim() || null
      };

      // Só incluir senha se foi preenchida
      if (formData.password.trim()) {
        updateData.password = formData.password;
      }

      const response = await axios.put(`/api/usuarios/${editingUser.id}`, updateData);

      if (response.data.success) {
        setSuccess('Usuário atualizado com sucesso!');
        resetForm();
        carregarUsuarios();
      } else {
        setError(response.data.message || 'Erro ao atualizar usuário');
      }
    } catch (error) {
      console.error('Error updating user:', error);
      setError('Erro ao atualizar usuário: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  const excluirUsuario = async (userId, userName) => {
    if (!window.confirm(`Tem certeza que deseja excluir o usuário "${userName}"?`)) {
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await axios.delete(`/api/usuarios/${userId}`);

      if (response.data.success) {
        setSuccess('Usuário excluído com sucesso!');
        carregarUsuarios();
      } else {
        setError(response.data.message || 'Erro ao excluir usuário');
      }
    } catch (error) {
      console.error('Error deleting user:', error);
      setError('Erro ao excluir usuário: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  const iniciarEdicao = (usuario) => {
    setEditingUser(usuario);
    setFormData({
      name: usuario.name,
      email: usuario.email,
      password: '',
      nome: usuario.nome || '',
      documento: usuario.documento || ''
    });
    setShowCreateForm(true);
    setError('');
    setSuccess('');
  };

  const renderFormulario = () => {
    if (!showCreateForm) return null;

    return (
      <div className="usuario-form">
        <h3>{editingUser ? '✏️ Editar Usuário' : '➕ Criar Novo Usuário'}</h3>
        
        <div className="form-fields">
          <div className="form-row">
            <div className="form-group">
              <label className="field-label">
                <span>👤</span>
                Nome Completo <span className="required">*</span>
              </label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => handleFormChange('name', e.target.value)}
                placeholder="Nome completo do usuário"
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label className="field-label">
                <span>📧</span>
                Email <span className="required">*</span>
              </label>
              <input
                type="email"
                value={formData.email}
                onChange={(e) => handleFormChange('email', e.target.value)}
                placeholder="email@exemplo.com"
                className="form-input"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="field-label">
                <span>👨‍💼</span>
                Nome (Advogado)
              </label>
              <input
                type="text"
                value={formData.nome}
                onChange={(e) => handleFormChange('nome', e.target.value)}
                placeholder="Nome profissional do advogado (opcional)"
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label className="field-label">
                <span>🏛️</span>
                Documento (OA)
              </label>
              <input
                type="text"
                value={formData.documento}
                onChange={(e) => handleFormChange('documento', e.target.value)}
                placeholder="Número da OA ou documento profissional (opcional)"
                className="form-input"
              />
            </div>
          </div>

          <div className="form-group">
            <label className="field-label">
              <span>🔒</span>
              Senha {editingUser ? <small>(deixe em branco para não alterar)</small> : <span className="required">*</span>}
            </label>
            <input
              type="password"
              value={formData.password}
              onChange={(e) => handleFormChange('password', e.target.value)}
              placeholder={editingUser ? "Nova senha (opcional)" : "Senha com pelo menos 6 caracteres"}
              className="form-input"
            />
          </div>
        </div>

        <div className="form-actions">
          <button 
            className="action-btn save-btn"
            onClick={editingUser ? editarUsuario : criarUsuario}
            disabled={loading}
          >
            {loading ? '⏳ Salvando...' : (editingUser ? '💾 ATUALIZAR' : '➕ CRIAR')}
          </button>
          <button 
            className="action-btn cancel-btn"
            onClick={resetForm}
            disabled={loading}
          >
            ❌ CANCELAR
          </button>
        </div>
      </div>
    );
  };

  const renderUsuarios = () => {
    if (loading && usuarios.length === 0) {
      return (
        <div className="loading-usuarios">
          <span>⏳</span>
          <span>Carregando usuários...</span>
        </div>
      );
    }

    if (usuarios.length === 0) {
      return (
        <div className="no-usuarios">
          <span>👥</span>
          <span>Nenhum usuário encontrado</span>
        </div>
      );
    }

    return (
      <div className="usuarios-list">
        <h3>👥 Usuários Cadastrados ({usuarios.length})</h3>
        
        <div className="usuarios-table">
          <div className="table-header">
            <div className="table-cell">ID</div>
            <div className="table-cell">Nome</div>
            <div className="table-cell">Email</div>
            <div className="table-cell">Nome Adv.</div>
            <div className="table-cell">Doc./OA</div>
            <div className="table-cell">Ações</div>
          </div>
          
          {usuarios.map(usuario => (
            <div key={usuario.id} className="table-row">
              <div className="table-cell">{usuario.id}</div>
              <div className="table-cell">{usuario.name}</div>
              <div className="table-cell">{usuario.email}</div>
              <div className="table-cell">{usuario.nome || '-'}</div>
              <div className="table-cell">{usuario.documento || '-'}</div>
              <div className="table-cell">
                <div className="row-actions">
                  <button
                    className="mini-btn edit-btn"
                    onClick={() => iniciarEdicao(usuario)}
                    disabled={loading}
                    title="Editar usuário"
                  >
                    ✏️
                  </button>
                  <button
                    className="mini-btn delete-btn"
                    onClick={() => excluirUsuario(usuario.id, usuario.name)}
                    disabled={loading}
                    title="Excluir usuário"
                  >
                    🗑️
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="usuarios-container">
      <div className="usuarios-header">
        <h2>👥 Gerenciar Usuários</h2>
        <p>Criação e gerenciamento de usuários do sistema</p>
      </div>

      <div className="usuarios-content">
        <div className="usuarios-actions">
          <button 
            className="create-user-btn"
            onClick={() => setShowCreateForm(!showCreateForm)}
            disabled={loading}
          >
            {showCreateForm ? '📋 VER LISTA' : '➕ NOVO USUÁRIO'}
          </button>
          
          <button 
            className="refresh-btn"
            onClick={carregarUsuarios}
            disabled={loading}
          >
            🔄 ATUALIZAR
          </button>
        </div>

        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}

        {showCreateForm ? renderFormulario() : renderUsuarios()}
      </div>
    </div>
  );
};

export default Usuarios;